<template lang="pug">
section
  div
    | Make yourself familiar with
    |
    a(
      href="https://www.gov.uk/government/collections/sponsorship-information-for-employers-and-educators",
      target="_blank"
    )
      | Home Office guidance for sponsors
    |
    | that sets out the process
    | for applying for a sponsor licence.

  br

  div
    | To obtain a sponsor licence,
    | UK employers need to follow the below steps:

  br

  ol
    li
      | Check if your business meets criteria
      | of eligibility and suitability to be a sponsor,
      | i.e. ensure that you can provide
      | the required supporting documents
      | to demonstrate your company is genuine
      | and actively trading in the UK;
    li
      | Decide on the type of licence you need;
    li
      | Appoint key personnel,
      | who will manage sponsorship
      | within your business;
    li
      | Prepare an online application and gather
      | all required supporting documents;
    li
      | Submit an online application and pay the fee.
</template>

<script>
export default {
  name: "application_process",
};
</script>

<style lang="scss" scoped>
ol {
  padding: 0;
  counter-reset: list;

  li {
    list-style: none;

    &::before {
      content: counter(list) ") ";
      counter-increment: list;
    }
  }
}
</style>